document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.proven-career-path-clone .content .card');
    const simplifyCards = document.querySelectorAll('.proven-career-path-clone .content .simplify');

    if (simplifyCards.length > 0) {
        return;
    }

    if (cards.length > 0) {
        cards[cards.length - 1].classList.add('inverted-last-card');
    }
});